import Model from '@/lib/data/Model';

class AddressTradeCode extends Model {
    static idProperty = 'id';

    fields = [
        { name: 'id' },
        { name: 'parent_id' },
        { name: 'name' },
        { name: 'trade_code' },
        { name: 'uw_cat' },
    ];

    constructor(data) {
        super(data);
        this.init();
    }

    api = [];
}

export default AddressTradeCode;
